import { FC, useState } from "react";
// 组件
import { ProModal, ProCheckbox, } from "../antd";
// 方法
import { responseError } from '../utils/messageUtils';
import { renderConditionLabel } from "./util";
// 常量
import { CheckColumnsProps, conditionType } from "./interface";

/** 选择需要复制的字段 */
const CheckColumns: FC<CheckColumnsProps> = props => {
  const { checkModalTitle, copyColumns, condition, checkColumnsRef, isMainSubTable, onOk, } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [checkCondition, setCheckCondition] = useState<conditionType[]>(isMainSubTable ? ['repeat', 'subTable'] : ['repeat']);
  const [fieldNames, setFieldNames] = useState<string[]>();
  /** 显示 */
  const handleShow = () => {
    setFieldNames(undefined);
    setOpen(true);
  };
  /** 隐藏 */
  const handleHide = () => {
    setOpen(false);
  };
  /** 点击确认 */
  const handleOk = () => {
    if (Array.isArray(fieldNames) && fieldNames.length) {
      onOk(fieldNames, checkCondition);
      handleHide();
      return;
    }
    responseError('请选择需要复制的数据！');
  };
  /** 对外方法 */
  checkColumnsRef.current = {
    show: handleShow,
    hide: handleHide,
  };
  
  return (
    <ProModal
      title={checkModalTitle}
      maskClosable={false}
      destroyOnClose
      open={open}
      onCancel={handleHide}
      onOk={handleOk}
    >
      <div className="check-columns-repeat">
      <ProCheckbox.Group
        value={checkCondition}
        onChange={values => setCheckCondition(values)}
      >
        {
          condition?.map(item => {
            return (
              <ProCheckbox key={item} value={item}>{renderConditionLabel(item)}</ProCheckbox>
            );
          })
        }
      </ProCheckbox.Group>
      </div>
      <div className="check-columns-group">
        <ProCheckbox.Group
          value={fieldNames}
          onChange={values => setFieldNames(values)}
        >
          {
            copyColumns?.map(item => {
              const { title, name, } = item;
              if (!title || !name) return null;
              return (
                <div className="check-columns-group-item" key={item.name}>
                  <ProCheckbox value={name}>{title}</ProCheckbox>
                </div>
              );
            })
          }
        </ProCheckbox.Group>
      </div>
    </ProModal>
  );
};

CheckColumns.defaultProps = {
  checkModalTitle: '请选择需要复制的列',
};

export default CheckColumns;
